import { css } from 'styled-components';

const styles = css`
  .smooth-scroll-list {
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    width: 100%;
    -ms-overflow-style: none;
    height: 100%;
  }
  .smooth-scroll-list::-webkit-scrollbar {
    display: none;
  }
  .smooth-scroll-list-item {
    display: inline-block;
    vertical-align: top;
    white-space: normal;
    height: 100%;
    min-width: 130px;
    width: 33%;
    margin-right: 0;
    ${(props) =>
      props.isRecommendationCarouselRedesignEnabled &&
      `
    @media ${props.theme.mediaQuery.smallOnly} {
      margin-right: 18px;
    }`}
  }
  .smooth-scroll-list-item:last-child {
    margin-right: 100px;
  }
  .bia-container {
    background-color: white;
    padding: 24px 0 0px 0;
    border-radius: 10px;
    margin: 20px 0px;
  }
  .bia-header {
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-weight: 700;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    font-size: 16px;
    margin-top: 0px;
    margin-bottom: 10px;
  }
  .header-container {
    display: flex;
    justify-content: space-between;
    padding: 0px 10px;
    width: 97%;
    margin-left: auto;
    margin-right: auto;
  }
  .outerCont {
    display: flex;
    flex-wrap: wrap;
  }
  .intcont {
    width: 200px;
  }

  .shop-all-cta {
    margin-right: 10px;
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    text-align: right;
    letter-spacing: 0.2px;
    text-decoration-line: underline;
    cursor: pointer;
    color: ${(props) => props.theme.colors.PRIMARY.DARK};
    text-transform: capitalize;
    margin-top: 0px;
  }
  .shop-all-cont {
    width: 100%;
    padding-top: 10px;
  }
  .multiline-ellipsis {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .product-title-container {
    margin-top: 0;
    box-sizing: border-box;
    height: 57px !important;
    padding-top: 4px;
  }
  .slick-track {
    margin-left: 0px !important ;
  }
  .product-brand-plp {
    color: ${(props) => props.theme.colors.TEXT.BRANDGRAY};
    font-size: 10px;
  }
  .bia-shop-all {
    margin-top: 28px;
    margin-right: 16px;
    font-family: 'Nunito';
    font-style: normal;
    letter-spacing: 0.2px;
    -webkit-text-decoration-line: underline;
    text-decoration-line: underline;
    cursor: pointer;
    color: ${(props) => props.theme.colors.PRIMARY.DARK};
    justify-content: center;
    display: flex;
    font-weight: 800;
    font-size: 14px;
    line-height: 19px;
  }

  .recommendations-section-col {
    ${(props) =>
      props.isRecommendationCarouselRedesignEnabled
        ? `
    width: 100%;
    margin-left: 2%;`
        : `width: 82.5%;
    margin-left: 9%;`}
  }

  ${(props) =>
    props.isRecommendationCarouselRedesignEnabled &&
    `
  .recommendations-section-col .slick-arrow {
    width: ${props.theme.spacing.ELEM_SPACING.XXL};
    height: ${props.theme.spacing.ELEM_SPACING.XXL};
    border-radius: ${props.theme.spacing.ELEM_SPACING.XS_6};
    border: 1px solid ${props.theme.colorPalette.gray[500]};
    background-color: ${props.theme.colors.GHOST_OVERLAY};
    display: none !important;
  }
  .recommendations-section-col .slick-slider {
    ${props.orderItemsCount > 0 ? 'padding-right: 24px' : 'padding-right: 42px'};
  }
  .slick-arrow.slick-prev {
    left: ${props.theme.spacing.ELEM_SPACING.XS};
  }

  .slick-arrow.slick-next {
    right:  ${props.orderItemsCount > 0 ? '38px' : '50px'};

  }

  &:hover .slick-arrow,
  &:focus-within .slick-arrow {
    display: block !important;
  }

  .slick-arrow.slick-disabled {
    display: none !important;
  }
  .bia-shop-all {
    justify-content: flex-end;
    margin-bottom: 12px;
  }
  `}
  .recommendations-section-row {
    ${(props) =>
      props.isRecommendationCarouselRedesignEnabled
        ? `
    padding-top: 24px;`
        : `padding: 30px 0 32px 0;`}
    overflow: hidden;
    @media ${(props) => props.theme.mediaQuery.desktop} {
      ${(props) =>
        props.isPDP && props.isRecommendationMarginEnabled && 'overflow: unset !important;'}
    }
    ${(props) => props.isVerticalRecommendationsEnabled && `width:300px;overflow-y:auto;`}
  }

  @media only screen and (min-width: 360px) and (max-width: 767px) {
    .recommendations-section-row {
      ${(props) =>
        props.isRecommendationCarouselRedesignEnabled
          ? `
          width: 98%;
      padding-top: 12px;`
          : `padding: 12px 0 24px 0;`}
    }

    .recommendations-section-col {
      width: 125%;

      ${(props) =>
        props.isRecommendationCarouselRedesignEnabled
          ? `margin: 14px;`
          : `margin-left: auto;
          margin-right: auto;`}
    }
  }

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    .bia-shop-all {
      margin-top: 2px;
    }
  }
  @media screen and (max-width: 350px) {
    .bia-shop-all {
      margin-top: 2px;
    }
  }
`;

export default styles;
